import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/aceisf/isf5'
import pathMap from 'src/paths/pathMap'

class AceISF5Route {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACEISF5_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACEISF5_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACEISF5_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACEISF5_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AceISF5Route
